import { afterSetState, isRunningStandalone, isset } from "legacy/helpers.es6"
import SearchDropdown from "legacy/marina-search/SearchDropdown"
import PropTypes from "prop-types"
import React from "react"

class MarinaSearchController extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fullInputText: this.props.searchTerm,
      typedText: null,
      displayDropdown: false,
      navigatingAway: false,
      selectedItem: null,
      highlightedItemIndex: null,
    }
    this.deleteAction = false
    this.didAutocomplete = false
    this.keyDown = this.keyDown.bind(this)
    this.selectLastItem = this.selectLastItem.bind(this)
    this.selectNextItem = this.selectNextItem.bind(this)
    this.setSelectedItem = this.setSelectedItem.bind(this)
    this.searchChange = this.searchChange.bind(this)
    this.deleting = this.deleting.bind(this)
    this.fetchAutoComplete = _.debounce(
      this.fetchAutoComplete.bind(this),
      this.props.searchDebounce
    )
    this.didFetchResults = this.didFetchResults.bind(this)
    this.showDropdownWithoutMatchedAutoComplete =
      this.showDropdownWithoutMatchedAutoComplete.bind(this)
    this.noResults = this.noResults.bind(this)
    this.clearItem = this.clearItem.bind(this)
    this.setNavigatingAway = this.setNavigatingAway.bind(this)
    this.submitBtn = this.submitBtn.bind(this)
    this.amplitudeExperienceName = this.amplitudeExperienceName.bind(this)
    this.amplitudeDestinationChosen = this.amplitudeDestinationChosen.bind(this)
    this.amplitudeLocationChosen = this.amplitudeLocationChosen.bind(this)
    this.amplitudeFindMarinasPressed =
      this.amplitudeFindMarinasPressed.bind(this)
    this.amplitudeSearchDropdownItemPressed =
      this.amplitudeSearchDropdownItemPressed.bind(this)
    this.submit = this.submit.bind(this)
    this.loadPage = this.loadPage.bind(this)
    this.search = null
    this.setSearchElementRef = (element) => {
      this.search = element
    }
  }

  componentDidMount() {
    if (isset(this.state.fullInputText) === false && !isRunningStandalone()) {
      this.search.focus()
    }
  }

  keyDown(event) {
    const key = event.keyCode || event.charCode
    if (key === 8 || key === 46) {
      this.deleteAction = true
    }
    if (key === 38) {
      // arrow up
      event.preventDefault()
      if (isset(this.state.results) && this.state.results.length > 0) {
        this.selectLastItem(this.state.highlightedItemIndex)
      }
    }
    if (key === 40) {
      // arrow down
      event.preventDefault()
      if (isset(this.state.results) && this.state.results.length > 0) {
        this.selectNextItem(this.state.highlightedItemIndex)
      }
    }
  }

  selectLastItem(index) {
    if (isset(index)) {
      if (index === 0) {
        index = null
      } else {
        index--
      }
    } else {
      index = this.state.results.length - 1
    }
    this.setSelectedItem(index)
  }

  selectNextItem(index) {
    if (isset(index)) {
      if (this.state.results.length - 1 === index) {
        index = null
      } else {
        index++
      }
    } else {
      index = 0
    }
    this.setSelectedItem(index)
  }

  setSelectedItem(index) {
    this.setState({ highlightedItemIndex: index })
    if (isset(index)) {
      this.setState({
        selectedItem: this.state.results[index],
        fullInputText: this.state.results[index].name,
      })
    } else {
      this.setState({
        selectedItem: null,
        fullInputText: this.state.typedText,
      })
    }
  }

  searchChange(event) {
    const searchTerm = event.target.value
    if (this.props.setParentState) {
      this.props.setParentState(searchTerm)
    }
    this.setState({
      typedText: searchTerm,
      highlightedItemIndex: null,
    })
    this.runningKeyPress = Math.random()

    if (this.deleting(searchTerm)) {
      return
    }

    this.deleteAction = false
    this.didAutocomplete = false
    if (isset(searchTerm) === false) {
      this.setState({
        fullInputText: null,
        displayDropdown: false,
      })
    } else {
      this.setState({ fullInputText: searchTerm })
      this.fetchAutoComplete(event.target, searchTerm, this.runningKeyPress)
    }
  }

  deleting(val) {
    if (isset(val) === false) {
      this.setState({ displayDropdown: false })
    }
    if (this.deleteAction && this.didAutocomplete) {
      this.setState({
        fullInputText: val,
        selectedItem: null,
      })
      this.deleteAction = false
      this.didAutocomplete = false
      return true
    } else {
      return false
    }
  }

  fetchAutoComplete(el, val, key) {
    const urlParams = new URLSearchParams(window.location.search)

    const latitude = urlParams.get("lat")
    const longitude = urlParams.get("lon")

    let requestUrl = `/explore/autocomplete?query=${val}`

    if (latitude && longitude) {
      requestUrl += `&lat=${latitude}&lon=${longitude}`
    }

    $.get(
      requestUrl,
      (data) => {
        // this is to help with concurrent requests as people type and as results come back
        if (this.runningKeyPress === key) {
          this.setState({ results: data })
          afterSetState(this.didFetchResults.bind(this, el, val))
        }
      },
      "json"
    )
  }

  didFetchResults(el, val) {
    if (this.state.results.length > 0) {
      // Always show dropdown without autocompleting
      this.showDropdownWithoutMatchedAutoComplete()
    } else {
      this.noResults()
    }
  }

  showDropdownWithoutMatchedAutoComplete() {
    this.didAutocomplete = false
    this.setState({ displayDropdown: true })
    this.clearItem()
  }

  noResults() {
    this.didAutocomplete = false
    this.setState({ displayDropdown: false })
    this.clearItem()
  }

  clearItem() {
    this.setState({ selectedItem: null })
  }

  setNavigatingAway() {
    if (isset(this.props.onMapPage) === false) {
      this.setState({ navigatingAway: true })
    }
  }

  submitBtn() {
    if (this.state.navigatingAway) {
      return (
        <button className="btn btn-danger" type="submit" disabled="true">
          <i className="fa-kit fa-spinner fa-spin" />
          <span className="pl-2">Searching...</span>
        </button>
      )
    } else {
      return (
        <button className="btn btn-primary" type="submit">
          Find marinas
        </button>
      )
    }
  }

  amplitudeExperienceName() {
    return isset(this.props.onMapPage) ? "explore" : "home"
  }

  amplitudeDestinationChosen(item, index) {
    const eventProps = {
      marina_id: item.mcom_id,
      visible_form: item.visible_form,
      marina_name: item.name,
      search_term: this.state.fullInputText,
      search_id: this.props.searchId,
      experience_name: "search",
      card_position: index,
    }
    Amplitude.trackEvent("search:destination_pressed", eventProps)
  }

  amplitudeLocationChosen(item) {
    const eventProps = {
      experience_name: this.amplitudeExperienceName(),
      location: [item.name, item.description].join(", "),
      search_term: [item.name, item.description].join(", "),
    }
    Amplitude.trackEvent("search:location_chosen", eventProps)
  }

  amplitudeFindMarinasPressed(searchTerm) {
    if (this.props.experienceName) {
      const eventProps = {
        experience_name: this.props.experienceName,
        search_term: searchTerm,
      }
      Amplitude.trackEvent(
        `${this.props.experienceName}:find_marinas_pressed`,
        eventProps
      )
    }
  }

  amplitudeSearchDropdownItemPressed(item, index) {
    if (item.kind === "internal") {
      this.amplitudeDestinationChosen(item, index)
    } else {
      this.amplitudeFindMarinasPressed(this.props.searchTerm)
      this.amplitudeLocationChosen(item)
    }
  }

  submit(event) {
    event.preventDefault()
    this.amplitudeFindMarinasPressed(this.state.fullInputText)
    if (isset(this.state.selectedItem)) {
      this.loadPage(this.state.selectedItem)
    } else {
      if (isset(this.props.onMapPage)) {
        this.props.getLocation({ search: this.state.fullInputText })
        this.setState({ displayDropdown: false })
      } else {
        window.location.href = "/search/" + this.state.fullInputText
      }
    }
  }

  loadPage(item) {
    this.setNavigatingAway()
    if (item.kind === "internal") {
      window.location.href = "/explore/destination/" + item.id
    } else {
      if (isset(this.props.onMapPage)) {
        this.props.getLocation({
          search: item.name,
          google_place_id: item.google_place_id,
        })
        this.setState({
          displayDropdown: false,
          fullInputText: item.name,
          selectedItem: item,
        })
      } else {
        window.location.href =
          "/search/" + item.name + "/" + item.google_place_id
      }
    }
  }

  render() {
    return (
      <div className="marina-search-controller">
        <form
          className={`form-wrapper clearfix ${
            this.props.onMapPage && "map-page-wrapper"
          }`}
          action="#"
          acceptCharset="UTF-8"
          method="get"
          onSubmit={this.submit}
        >
          <label htmlFor="marinaSearch" className={"sr-only"}>
            Search
          </label>
          {!this.props.onMapPage && (
            <i className="fa-kit fa-search-mdi search-bar-icon text-xl" />
          )}
          <input
            id={"marinaSearch"}
            className={`form-control search-input ${
              this.state.displayDropdown && "active-dropdown"
            }`}
            onChange={this.searchChange}
            onKeyDown={this.keyDown}
            value={this.state.fullInputText || ""}
            ref={this.setSearchElementRef}
            name="search"
            placeholder="Search for a marina or location"
            type="text"
            autoComplete="off"
          />
          {this.submitBtn()}
          <SearchDropdown
            state={this.state}
            loadPage={this.loadPage}
            handleAmplitude={this.amplitudeSearchDropdownItemPressed}
          />
        </form>
      </div>
    )
  }
}

MarinaSearchController.propTypes = {
  searchTerm: PropTypes.string,
  searchDebounce: PropTypes.number,
  onMapPage: PropTypes.bool,
  getLocation: PropTypes.func,
  setParentState: PropTypes.func,
  experienceName: PropTypes.string,
  searchId: PropTypes.string,
}

export default MarinaSearchController
